<a class="nav-link" ngbDropdownToggle [id]="'navbarNotificationDropdown' + i">
  <img [src]="
      config.layout.skin === 'dark'
        ? 'assets/images/icons/menu-light.svg'
        : 'assets/images/icons/menu.svg'
    " style="height: 22px; width: 22px" alt="" />
</a>
<ul ngbDropdownMenu aria-labelledby="navbarNotificationDropdown"
  class="dropdown-menu dropdown-menu-media dropdown-menu-right" [ngClass]="i == '1' ? 'send-to-left' : ''">
  <li class="scrollable-container media-list">
    <div class="row mx-0 bg-white">
      <ng-container *ngFor="let section of sections; let i = index">
        <ng-container *renderIf="section.renderIf">
          <ng-container *ngFor="let module of section.children">

            <ng-container *ngIf="!module.external && (!isStartup || (section.section === 'iNest' && module.title !== 'Dashboard'))">
              <a *renderIf="module.renderIf" [routerLink]="module.link" [queryParams]="module.queryParams"
                class="menu-item mars-home-title d-flex flex-column align-items-center" (click)="dropdown.close()">
                <img [src]="module.icon" alt="" width="32" height="32" />
                <span>{{ module.title }}</span>
              </a>
            </ng-container>

            <ng-container *ngIf="module.external && (!isStartup || (section.section === 'iNest' && module.title !== 'Dashboard'))">
              <a *renderIf="module.renderIf" [href]="module.link" target="_self"
                class="menu-item mars-home-title d-flex flex-column align-items-center" (click)="dropdown.close()">
                <img [src]="module.icon" alt="" width="32" height="32" />
                <span>{{ module.title }}</span>
              </a>
            </ng-container>

          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </li>
</ul>